/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import Layout, { LayoutProps } from 'components/layout';
import { Hero } from 'components/sections/hero';
import { ContactUs } from 'components/sections/contactus';
import { Faq } from 'components/sections/faq';
import { useInView } from 'react-intersection-observer';
import { Team } from 'components/sections/team';
//import { Resources } from 'components/sections/resources';

export interface HomePageProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: any;
}

const Home = (props: HomePageProps): JSX.Element => {
    const { children } = props;

    // const [isTeamInViewport, teamTargetRef, viewportRefToChainTeam] = useIsInViewport({
    //     threshold: 50,
    // });
    // const [isFaqInViewport, faqTargetRef, viewportRefToChainFaq] = useIsInViewport({
    //     viewport: viewportRefToChainTeam,
    //     threshold: 50,
    // });
    // const [isContactInViewport, contactTargetRef, viewportRef] = useIsInViewport({
    //     viewport: viewportRefToChainFaq,
    //     threshold: 50,
    // });
    const [teamTargetRef, isTeamInViewport] = useInView({
        threshold: 0.5,
    });
    const [faqTargetRef, isFaqInViewport] = useInView({
        threshold: 0.5,
    });
    const [contactTargetRef, isContactInViewport] = useInView({
        threshold: 0.5,
    });
    // const [resourcesTargetRef, isResourcesInViewport] = useInView({
    //     threshold: 0.5,
    // });

    const check = (value: boolean | null) => value !== null && value;

    // : check(isResourcesInViewport)
    // ? 'resources'
    const currentPage = check(isContactInViewport)
        ? 'contact'
        : check(isFaqInViewport)
        ? 'faq'
        : check(isTeamInViewport)
        ? 'ourteam'
        : 'home';
    const layoutProps: LayoutProps = {
        isHome: false,
        currentPage,
        children,
    };
    return (
        <div>
            <Layout {...layoutProps}>
                <Hero />
                <div className="homealertwrapper">
                    <div className="alert alert-secondary" role="alert">
                        <div className="homealert">
                            <p>
                                Calvary Paediatrics is now closed as of 23rd January 2026. All doctors and staff now
                                attend The Paediatric Practice.
                            </p>
                            <p>
                               Suite 13 Football House. 5 Phipps Close, Deakin.
                               <br />
                                Email: reception@thepaediatricpractice.com.au.
                                <br />
                               Phone: 5137 3630
                            </p>
                        </div>
                    </div>
                </div>
                <div className="homealertwrapper">
                    <div className="alert alert-secondary" role="alert">
                        <div className="homealert">
                            <p>Unfortunately, Dr Rosier&apos;s books are closed for new referrals.</p>
                        </div>
                    </div>
                </div>
                <div ref={teamTargetRef}>
                    <Team />
                </div>
                <div ref={faqTargetRef}>
                    <Faq />
                </div>
                {/* <div ref={resourcesTargetRef}>
                    <Resources />
                </div> */}
                <div ref={contactTargetRef}>
                    <ContactUs />
                </div>
            </Layout>
        </div>
    );
};

export default Home;
